
const DialogTitle = ({children}) => {

    return (
        <p className="dialog-title">{children}</p>
    )
}

export default DialogTitle;
